import { Checkbox, FormControlLabel } from "@mui/material"

const BaseCheckbox = ({ checked, onChange, label, required, sx }) => {
  return (
    <FormControlLabel
      sx={{
        '& .MuiFormControlLabel-label': {
          fontSize: '15px',
          whiteSpace: 'nowrap',
          ...sx
        }
      }}
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          sx={{
            color: 'primary.mediumGray',
            '& .MuiSvgIcon-root': { 
              fontSize: '28px'
            },
            '&.Mui-checked': {
              color: 'primary.mainBlue',
            },
          }}
        />
      }
      label={label}
      required={required}
    />
  )
}

export default BaseCheckbox